import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Table } from "../../common/Table/Table";
import { StatusBadge } from "../../common/Table/StatusBadge/StatusBadge";
import InputField from "../../common/InputField/InputField";

export const KbIngestionLogs = () => {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Mock data - replace with actual API call in production
  const mockData = [
    {
      id: "ing123",
      documentName: "Document 1.pdf",
      status: "completed",
      date: "2023-10-15",
      size: "2.4MB",
    },
    {
      id: "ing456",
      documentName: "Manual.pdf",
      status: "failed",
      date: "2023-10-16",
      size: "3.8MB",
    },
  ];

  const columns = [
    {
      key: "id",
      header: t("logs.ingestionId"),
      align: "center",
    },
    {
      key: "documentName",
      header: t("logs.documentName"),
      align: "left",
    },
    {
      key: "status",
      header: t("logs.status"),
      align: "center",
    },
    {
      key: "date",
      header: t("logs.date"),
      align: "center",
    },
    {
      key: "size",
      header: t("logs.size"),
      align: "center",
    },
  ];

  const renderCustomCell = (item, key) => {
    if (key === "status") {
      return (
        <StatusBadge status={item.status} text={t(`status.${item.status}`)} />
      );
    }
    return item[key];
  };

  return (
    <Container>
      <SearchContainer>
        <InputField
          placeholder={t("logs.searchByDocumentName")}
          value={searchQuery}
          onChange={setSearchQuery}
        />
      </SearchContainer>

      <Table
        columns={columns}
        data={mockData}
        isLoading={isLoading}
        emptyMessage={t("logs.noResults")}
        loadingMessage={t("logs.loading")}
        renderCustomCell={renderCustomCell}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const SearchContainer = styled.div`
  width: 100%;
  max-width: 400px;
  margin-bottom: 1.5rem;
`;
